import React, { Component } from 'react';
import Collapse, { Panel } from 'rc-collapse';
import { Element } from 'react-scroll';
import Checkboxes from '../form/base/Checkboxes';
import Radio from '../form/base/Radio';
import { ErrorMessage, FormikConsumer } from 'formik';

class ServiceTab extends Component {
  constructor(props) {
    super(props);

    this.state = { showError: false };
  }

  render() {
    const { formData } = this.props;

    return (
      <FormikConsumer>
        {({ errors, touched }) => {
          const hasTouched = touched['support_services'] || touched['prevention_services'] || touched['testing_services'] || touched['care_and_treatment_services'];
          const hasErrors = errors['support_services'] || errors['prevention_services'] || errors['testing_services'] || errors['care_and_treatment_services'];

          return (
            <div>
              <h2>Services</h2>
              <div className="description">Please select at least one service</div>
              <div className="form-error-message">
                <Element name="org.services.at_least_one">
                  <ErrorMessage name="support_services" />
                </Element>
              </div>
              <Collapse accordion={false} defaultActiveKey={['0', '1', '2', '3']}>
                <Panel header="Support Services">
                  <Checkboxes options={formData.support_services}
                    name="support_services"
                    hasError={hasTouched && hasErrors} />
                </Panel>
                <Panel header="Prevention Services">
                  <Checkboxes options={formData.prevention_services}
                    name="prevention_services"
                    hasError={hasTouched && hasErrors} />
                </Panel>
                <Panel header="Testing Services">
                  <Checkboxes options={formData.testing_services}
                    name="testing_services"
                    hasError={hasTouched && hasErrors} />

                  <Radio label="Does your organization offer self-testing kits?"
                    name="offer_self_testing"
                    options={[
                      { label: 'N/A', value: '_none' },
                      { label: 'Yes', value: '1' },
                      { label: 'No', value: '0' }
                    ]} />
                </Panel>
                <Panel header="Health Care & Treatment">
                  <Checkboxes options={formData.care_and_treatment_services}
                    name="care_and_treatment_services"
                    hasError={hasTouched && hasErrors} />
                </Panel>
              </Collapse>
              <div className="submit">
                <button type="button" className='usa-button' onClick={this.props.nextTab}>Save and continue</button>
              </div>
            </div>
          )
        }}
      </FormikConsumer>
    )
  }
}

export default ServiceTab;
